import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import WhatIDo from './components/WhatIDo';
import Approach from './components/Approach';
import CurrentWorks from './components/CurrentWorks';
import SelectedCases from './components/SelectedCases';
import Archive from './components/Archive';
import Career from './components/Career';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  const location = useLocation();

  // Scroll to archive section when returning from case detail
  useEffect(() => {
    const shouldScroll = sessionStorage.getItem('scrollToArchive');
    if (shouldScroll) {
      sessionStorage.removeItem('scrollToArchive');
      window.setTimeout(() => {
        document.getElementById('archive')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 300);
    }
  }, []);

  // Scroll to hash target (e.g. /#archive from a case detail page)
  useEffect(() => {
    if (!location.hash) return;
    const id = location.hash.replace('#', '');
    window.setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 300);
  }, [location.hash]);

  return (
    <div className="min-h-screen bg-background-50 text-foreground-950 font-body">
      <Navbar />
      <main>
        <Hero />
        <WhatIDo />
        <Approach />
        <CurrentWorks />
        <SelectedCases />
        <Archive />
        <Career />
        <About />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}